export default {
  en: 'English',
  es: 'Español',
  wd: 'Testing',
};
